import { FDealType } from './jsonQuery';

/**
 * Возвращает true, если выбрана аренда.
 */
export function isRent(dealType: FDealType): boolean {
  return dealType === FDealType.RentLongterm || dealType === FDealType.RentDaily || dealType === FDealType.Rent;
}
